import { Box } from "@mui/material"
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation"
import React, { useCallback, useEffect } from "react"

import useTranslate, { Namespaces } from "../../../../hooks/use-translate"
import { reReadAriaLabel, s } from "../../../../utilities/common"
import { theme } from "../../../../utilities/theme"
import { usePlayer } from "../../use-player"

export const PlayButton = ({ focusKey }: { focusKey?: string }) => {
  const t = useTranslate(Namespaces.Common)
  const { play, pause, paused } = usePlayer()

  const onPress = useCallback(() => {
    if (paused) {
      play()
    } else {
      pause()
    }
    reReadAriaLabel(ref)
  }, [paused, play, pause])

  const { focused, focusSelf, ref } = useFocusable({
    focusKey: focusKey,
    onEnterPress: onPress,
  })

  useEffect(() => {
    focusSelf()
  }, [focusSelf])

  return (
    <Box
      tabIndex={0}
      aria-label={t(paused ? "player__button_play" : "player__button_pause")}
      onMouseEnter={() => focusSelf({ noScroll: true })}
      onMouseDown={onPress}
      ref={ref}
    >
      {paused ? (
        <svg
          width={s("112")}
          height={s("112")}
          viewBox="64 52 112 112"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="120"
            cy="108"
            r="56"
            fill={focused ? "white" : "#303030"}
          />
          <path
            d="M108.188 128.656C107.25 128.656 106.477 128.32 105.867 127.648C105.258 126.992 104.953 126.086 104.953 124.93V93.1016C104.953 91.9453 105.258 91.0391 105.867 90.3828C106.477 89.7109 107.25 89.375 108.188 89.375C108.672 89.375 109.141 89.4609 109.594 89.6328C110.047 89.7891 110.539 90.0234 111.07 90.3359L137.297 105.523C138.281 106.086 138.992 106.633 139.43 107.164C139.867 107.68 140.086 108.297 140.086 109.016C140.086 109.75 139.867 110.375 139.43 110.891C138.992 111.406 138.281 111.945 137.297 112.508L111.07 127.719C110.539 128.031 110.047 128.266 109.594 128.422C109.141 128.578 108.672 128.656 108.188 128.656Z"
            fill={focused ? "#0A0F17" : "white"}
          />
        </svg>
      ) : (
        <svg
          width={s("112")}
          height={s("112")}
          viewBox="64 52 112 112"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="120"
            cy="108"
            r="56"
            fill={focused ? "white" : theme.palette.new.playerButton}
          />
          <path
            d="M108.844 127.578C107.75 127.578 106.922 127.305 106.359 126.758C105.812 126.211 105.547 125.391 105.562 124.297V93.6875C105.562 92.6094 105.836 91.7969 106.383 91.25C106.93 90.7031 107.75 90.4297 108.844 90.4297H114.094C115.172 90.4453 115.984 90.7188 116.531 91.25C117.078 91.7812 117.352 92.5938 117.352 93.6875V124.297C117.352 125.391 117.078 126.211 116.531 126.758C115.984 127.305 115.172 127.578 114.094 127.578H108.844ZM125.906 127.578C124.812 127.578 123.992 127.305 123.445 126.758C122.898 126.211 122.625 125.391 122.625 124.297V93.6875C122.625 92.6094 122.898 91.7969 123.445 91.25C124.008 90.7031 124.828 90.4297 125.906 90.4297H131.18C132.242 90.4297 133.047 90.7031 133.594 91.25C134.156 91.7812 134.438 92.5938 134.438 93.6875V124.297C134.438 125.391 134.156 126.211 133.594 126.758C133.047 127.305 132.242 127.578 131.18 127.578H125.906Z"
            fill={focused ? theme.palette.new.playerButton : "white"}
          />
        </svg>
      )}
    </Box>
  )
}
